module.exports = __webpack_public_path__ + "static/media/messenger.b884b657.png";